function toMoney(
  price,
  {
    cents = true,
    no_zeros = true,
    no_decimals = false,
    is_discount = false,
    locale = window.Shopify.locale,
    currency = window.Shopify.currency.active,
    style = 'currency',
    currencyDisplay = 'narrowSymbol'
  } = {}
) {
  if (price === undefined || price === null) {
    return null;
  }

  let priceCopy = new Number(price);

  // Convert to dollars if the amount passed is in cents
  if (cents) {
    priceCopy /= 100;
  }

  const currencyOptions = {
    style,
    currency,
    currencyDisplay
  }

  if (no_decimals) {
    currencyOptions.minimumFractionDigits = 0;
    currencyOptions.maximumFractionDigits = 0;
  }

  let priceString = priceCopy.toLocaleString(locale, currencyOptions);

  if (no_zeros && priceString.indexOf('.00')) {
    priceString = priceString.replace('.00', '');
  }

  if (is_discount) {
    priceString = `-${priceString}`;
  }

  return priceString;
}

function keygen(prefix = '', sufix = '') {
  const chars = 'abcdefghijklmnopqrstuvwxyz1234567890';
  const rand = (min = 0, max = 1000) => Math.floor(Math.random() * (max - min) + min);
  const randChar = (length = 6) => {
    const randchars = [];
    for (let i = 0; i < length; i++) {
      randchars.push(chars[rand(0, chars.length)]);
    }
    return randchars.join('');
  }

  return `${prefix}${prefix ? '-' : ''}${randChar()}${sufix ? '-' : ''}${sufix}`;
}

function getSrcset(imageSrc, defaultSize, sizes = ['335', '500', '720', '900', '1080', '1296', '1512', '1728', '2376', '2592', '2808', '3024'], accentuate = false) {
  const prefix = accentuate ? `w_` : `width=`;
  const replaceText = `${prefix}${defaultSize}`;
  let srcset = '';
  for (size of sizes) {
    let newSrc = imageSrc.replace(replaceText, `${prefix}${size}`);
    srcset = `${srcset} ${newSrc} ${size}w,`;
  }
  return srcset;
}
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
function validatePassword(pass) {
  const re = /^[^\s]+$/;
  return re.test(pass);
}
// getFormfitCarriedSizes is mirrored by the server-rendered Precise Size™ conversion
// (snippets/pdp-fitform-calculator-ssr.liquid): keep both in sync. The server-rendered chart and conversion take the
// Precise Size™ of each bra size from ThirdLove's Precise Sizing™ chart instead of getMappedFormfitSize
// (snippets/precise-size-data.liquid)
function getMappedFormfitSize(braSize) {
  const mappedFormfitSizes = {
    "S+": ["30E½"],
    "XS": ["30C", "30C½"],
    "XS+": ["30D", "30D½", "30E"],
    "XS++": ["30F", "30G"],
    "SM": ["32B", "32B½", "32C", "32C½", "34A", "34A½"],
    "SM+": ["32D", "32D½", "32E"],
    "SM++": ["32F", "32G"],
    "MD": ["34B", "34B½", "34C", "34C½", "36A", "36A½"],
    "MD+": ["32E½","34D", "34D½", "34E"],
    "MD++": ["32H", "34F", "34G"],
    "LG": ["36B", "36B½", "36C", "36C½"],
    "LG+": ["36D", "36E"],
    "LG++": ["36F", "36G", "34H"],
    "XL": ["38B", "38B½", "38C"],
    "XL+": ["38D", "38E"],
    "XL++": ["36H", "38F", "38G"],
    "1X": ["40B", "40C"],
    "2X": ["40D", "40E", "42B", "42C"],
    "3X": ["42D", "42E", "44B", "44C", "44D"]
  }
  return Object.keys(mappedFormfitSizes).find(key => mappedFormfitSizes[key].includes(braSize));
}
function getMappedFormfitSizes(size) {
    const mappedFormfitSizes = {
    "S+": ["30E½"],
    "XS": ["30C", "30C½"],
    "XS+": ["30D", "30D½", "30E"],
    "XS++": ["30F", "30G"],
    "SM": ["32B", "32B½", "32C", "32C½", "34A", "34A½"],
    "SM+": ["32D", "32D½", "32E"],
    "SM++": ["32F", "32G"],
    "MD": ["34B", "34B½", "34C", "34C½", "36A", "36A½"],
    "MD+": ["32E½","34D", "34D½", "34E"],
    "MD++": ["32H", "34F", "34G"],
    "LG": ["36B", "36B½", "36C", "36C½"],
    "LG+": ["36D", "36E"],
    "LG++": ["36F", "36G", "34H"],
    "XL": ["38B", "38B½", "38C"],
    "XL+": ["38D", "38E"],
    "XL++": ["36H", "38F", "38G"],
    "1X": ["40B", "40C"],
    "2X": ["40D", "40E", "42B", "42C"],
    "3X": ["42D", "42E", "44B", "44C", "44D"]
  }

  return mappedFormfitSizes[size];
}

function getFormfitCarriedSizes() {
  return {
    "30": ["C", "C½", "D", "D½", "E", "F", "G"],
    "32": ["B", "B½", "C", "C½", "D", "D½", "E", "E½", "F", "G"],
    "34": ["A", "A½", "B", "B½", "C", "C½", "D", "D½", "E", "F", "G"],
    "36": ["A", "A½", "B", "B½", "C", "C½", "D", "E", "F", "G", "H"],
    "38": ["B", "B½", "C", "D", "E", "F", "G"],
    "40": ["B", "C", "D", "E"],
    "42": ["B", "C", "D", "E"],
    "44": ["B", "C", "D"],
  }
}
function getMappedAlphaSize(braSize) {
  const mappedSizes = {
    "XS": ["30C", "30C½", "30D", "30D½"],
    "SM": ["30E", "30E½", "30F", "32B", "32B½", "32C", "32C½", "32D", "32D½", "34A", "34A½"],
    "MD": ["32E", "32E½", "32F", "34B", "34B½", "34C", "34C½", "34D", "34D½", "36A", "36A½"],
    "LG": ["34E", "34F", "36B", "36B½", "36C", "36C½", "36D"],
    "XL": ["36E", "36F", "38B", "38B½", "38C", "38D"],
    "1X": ["38E", "38F", "40B", "40C"],
    "2X": ["40D", "40E", "42B","42C"],
    "3X": ["42D", "42E", "44B", "44C", "44D"]
  }
  if (braSize) {
    return Object.keys(mappedSizes).find(key => mappedSizes[key].includes(braSize));
  }
  return mappedSizes;
}
function getMappedKindredBravelySizes(braSize) {
  const mappedSizes = {
    "SMB": ["30E", "30F", "30G", "30H", "32E", "32F", "32G", "32H"],
    "MDB": ["34E", "34F", "34G", "34H"],
    "LGB": ["36E", "36F", "36G", "36H"],
    "XLB": ["38E", "38F", "38G", "38H", "40E", "40F", "40G", "40H"],
    "1XB": ["42E", "42F", "42G", "42H", "44E", "44F", "44G", "44H"],
    "2XB": ["46E", "46F", "46G", "46H"]
  }
  return Object.keys(mappedSizes).find(key => mappedSizes[key].includes(braSize));
}
function getBleuetSize(bandSize) {
  const mappedSizes = {
    "8": "24",
    "10": "26",
    "12": "28",
    "14": "30",
    "16": "32",
    "18": "34",
    "20": "36",
    "22": "38",
    "24": "40"
  }
  return Object.keys(mappedSizes).find(key => mappedSizes[key] == bandSize);
}
function getCarriedSizes() {
  return {
    "30": ["B", "C", "C½", "D", "D½", "E", "E½", "F", "G"],
    "32": ["A", "B", "B½", "C", "C½", "D", "D½", "E", "E½", "F", "G", "H"],
    "34": ["AA", "A", "A½", "B", "B½", "C", "C½", "D", "D½", "E", "E½", "F", "G", "H"],
    "36": ["A", "A½", "B", "B½", "C", "C½", "D", "E", "F", "G", "H"],
    "38": ["A", "A½", "B", "B½", "C", "D", "E", "F", "G", "H", "I"],
    "40": ["A", "A½", "B", "C", "D", "E", "F", "G", "H"],
    "42": ["B", "C", "D", "E", "F", "G"],
    "44": ["B", "C", "D", "E", "F"],
    "46": ["B", "C", "D", "E"],
    "48": ["B", "C", "D"]
  }
}
function getSizeChartType(type, title, vendor, tags) {
  if (tags.includes('teen_bra_chart')) {
    return 'teen';
  } else if (vendor === 'kit undergarments') {
    if (type === 'panties') {
      return 'kit_undergarments_underwear';
    }
    else if (type === 'sleepwear') {
      return tags.includes('alpha') ? 'kit_undergarments_bra' : 'kit_undergarments_lounge';
    }
    else {
      return 'kit_undergarments_bra';
    }
  }  else if (type === 'bra' && tags.includes('alpha')) {
    return 'wireless'; // o 'formfit' si prefieres ese
  } else if (tags.includes('precise_sizing')) {
    return 'formfit';
  } else if (title.includes('gatherall')) {
    return 'gatherall'
  } else if (title.includes('kindred bravely')) {
    return 'kindred-bravely';
  } else if (type === 'bra') {
    return 'bra';
  } else if (title.includes('bodysuit')) {
    return 'bodysuit';
  } else if (type === 'sleepwear') {
    return tags.includes('alpha') ? 'wireless' : 'lounge';
  } else if (title?.includes('nipple') || title?.includes('nippies')) {
    return 'nipple-covers';
  } else {
    return 'underwear';
  }
}
/**
 * Extracts the URL parameters into an object.
 *
 * @param {string} [url=window.location.href] - The URL to parse
 * @returns {object} The query parameters object.
 * @memberof Utilities
 * @example
 * // Returns { name: "Joe", email: "joe@thirdlove.com" }
 * getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40thirdlove.com');
 */
function getURLParams(url) {
  const finalUrl = url || window.location.href;
  // Get the string after the '?' from the URL
  const queryString = finalUrl.split(/\?([^\#]+)/)[1];

  if (!queryString) {
    return {};
  }

  return toObject(queryString);
}
function setURLParams(params, options = {}) {
  const currentParams = getURLParams();
  const newParams = options.clear ? {} : currentParams;
  const queryArray = [];
  let queryString = '';

  // Add new parameters
  Object.keys(params).forEach((key) => {
    const paramValue = params[key];
    newParams[key] = options.no_overwrite
      ? newParams[key] || paramValue
      : paramValue;
  });

  // Convert object to URL string
  Object.keys(newParams).forEach((key) => {
    queryArray.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(newParams[key])}`,
    );
  });

  if (queryArray.length) {
    queryString = `?${queryArray.join('&')}`;
  }

  if (options.push_state) {
    window.history.pushState({}, null, queryString);
  } else {
    window.history.replaceState({}, null, queryString);
  }
}
/**
 * Created an object from a parameter string.
 *
 * @param {string} object_string - The string to parse to an object.
 * @returns {object} The object created from the string.
 * @memberof Utilities
 * @example
 * // If called on a form that takes a name and email,
 * // could return { name: "Joe", email: "joe@thirdlove.com" }
 * toObject($form.serialize());
 */
function toObject(objectString) {
  const parameters = {};

  if (!objectString) {
    return {};
  }

  // Split into each element
  const elements = objectString.split('&');

  elements.forEach((element) => {
    const equalsIndex = element.indexOf('=');
    // check if the query has a value or is only a key
    if (equalsIndex === -1) {
      // if there's no = then it's only a key, so set the key to
      // the whole element and the value to null
      // Decode to get original characters
      parameters[decodeURIComponent(element)] = null;
    } else {
      // if there's an = then assign up to the = to be the key and
      // everything after to be the value (or null if empty)
      // Decode to get original characters
      const key = decodeURIComponent(element.slice(0, equalsIndex));
      const value = decodeURIComponent(element.slice(equalsIndex + 1)) || null;
      parameters[key] = value;
    }
  });

  return parameters;
}

// Return true if the product is final sale
const isFinalSale = tags => tags.includes('__label: Final Sale');

function waitForElement(selector, parent = document.body) {
  // eslint-disable-next-line consistent-return
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(parent, {
      childList: true,
      subtree: true,
    });
  });
}
function filterProductTags(tags) {
  if (!Array.isArray(tags) || !tags?.length) return [];
  return tags.filter(tag => {
    if (
      tag.includes('__label: Final Sale') || tag.includes('final-sale-') || tag.includes('-final-sale') ||
      tag.includes('bundled-') || tag.includes('-bundled') ||
      tag.includes('bundle-') || tag.includes('-bundle') ||
      tag.includes('bundling-') || tag.includes('-bundling') ||
      tag.includes('bundle-button-') || tag.includes('-bundle-button') ||
      tag.includes('bundle-discount-button-') || tag.includes('-bundle-discount-button') ||
      tag.includes('bundle-discount-button-ca-') || tag.includes('-bundle-discount-button-ca') ||
      tag.includes('test-discount-kit-') || tag.includes('-test-discount-kit-') ||
      tag.includes('test-discount-kit-ca-') || tag.includes('-test-discount-kit-ca') ||
      tag.includes('auto-bundle-') || tag.includes('-auto-bundle') ||
      tag.includes('auto-bundling-') || tag.includes('-auto-bundling') ||
      tag.includes('auto-bundled-') || tag.includes('-auto-bundled') ||
      tag.includes('gwp-') || tag.includes('-gwp') ||
      tag.includes('sgd-') || tag.includes('-sgd') ||
      tag.includes('bb-') || tag.includes('-bb') ||
      tag.includes('bd-') || tag.includes('-bd') ||
      tag.includes('ab-') || tag.includes('-ab') ||
      tag.includes('filter_style:') || tag.includes('filter-style:')
    ) {
      return true;
    }
    return false;
  });
}
async function getTrueSize() {
  const cookieUnderwearSize = getUserFittingRoomUnderwearSize();
  const cookieBandSize = getUserFittingRoomBandSize();
  const cookieCupSize = getUserFittingRoomCupSize();
  if (cookieUnderwearSize && cookieBandSize && cookieCupSize) {
    return {
      underwear_size: cookieUnderwearSize,
      bra_band: cookieBandSize,
      bra_cup: cookieCupSize
    };
  }
  let trueSizeEmail;
  let useBtoa = true;
  let trueSize = null;
  if (window.theme.customer.email) {
    trueSizeEmail = window.theme.customer.email;
  } else if (localStorage.getItem('true_size_email_btoa')) {
    trueSizeEmail = localStorage.getItem('true_size_email_btoa');
    useBtoa = false;
  }
  if (trueSizeEmail) {
    // Run api fetch
    trueSize = await fetchTrueSizeData(trueSizeEmail, useBtoa);
    if (trueSize) {
      if (trueSize.bra_band && trueSize.bra_cup) {
        jsCookie.set('_tl_persona_true_size_band_size', trueSize.bra_band, { expires: 365, domain });
        jsCookie.set('_tl_persona_true_size_cup_size', trueSize.bra_cup, { expires: 365, domain });
      }
      if (trueSize.underwear_size) {
        jsCookie.set('_tl_persona_true_size_underwear_size', trueSize.underwear_size, { expires: 365, domain });
      }
    }
  }
  return trueSize;
}
async function fetchTrueSizeData(email = null, useBtoa = true) {
  const timestamp = Math.floor(Date.now() / 1000);
  let authData = null;
  try {
    const response = await fetch(`${window.location.origin}/pages/auth/${timestamp}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const htmlData = await response.text();
    // Parse the HTML and extract content within <body> tags
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlData, 'text/html');
    if (doc) {
      doc.querySelectorAll('style').forEach((styleEl) => styleEl.remove());
      const jsonString = doc.body.textContent.trim();
      const jsonObject = JSON.parse(jsonString);
      authData = jsonObject;
    }
  } catch (error) {
    console.error("Error fetching auth data:", error);
    return false;
  }
  if (!authData || !email) {
    return false;
  }
  const key = useBtoa ? btoa(email) : email;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': authData.auth || '',
    'x-time': authData.time || null
  };
  let result = null;
  try {
    const response = await fetch(window.theme.ts_api.ts_fetch, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ key })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    result = await response.json();
  } catch (error) {
    console.error("Error fetching true size data:", error);
  }
  return result;
}
function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction(...args) {
    const context = this;
    const later = () => {
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
const filterSettingsByCountry = (settings) => Object.entries(settings).reduce((acc, curr, arr) => {
  const country = window.Shopify.country;
  if (curr[0].slice(-2) === 'Ca' && country === 'CA') {
    const key = curr[0].slice(0, -2);
    acc[key] = curr[1];
  } else if (curr[0].slice(-2) !== 'Ca' && country !== 'CA') {
    acc[curr[0]] = curr[1];
  }
  return acc;
}, {});
async function getAuthData() {
  let result = null;
  try {
    const response = await fetch('/?view=pskey', { method: 'GET' });
    if (response.ok) {
      result = await response.json();
    }
  } catch (error) {
    console.error('Error fetching auth data:', error);
  }
  return result;
}

const getUserFittingRoomBandSize = () => jsCookie.get('_tl_persona_true_size_band_size');
const getUserFittingRoomCupSize = () => jsCookie.get('_tl_persona_true_size_cup_size');
const getUserFittingRoomUnderwearSize = () => jsCookie.get('_tl_persona_true_size_underwear_size');
